import { AvatarProps, Divider, MenuItem, Persona } from "@fluentui/react-components";
import React, { useCallback, useMemo } from "react";

import { InteractionType } from "@azure/msal-browser";
import { PersonAddRegular } from "@fluentui/react-icons";
import { UserDropDownCachedUser } from "./UserDropDownCachedUser";
import { observer } from "mobx-react";
import { useGlobalSetting } from "Store/GlobalSettingStore";
import { useRootStore } from "Store/RootStore";
import { useStyles } from "./UserDropDown.styles";
import { useNavigate } from "react-router";

const UserDropDownCachedUsersBase = () => {
    const classNames = useStyles();
    const { noneLoginUsers } = useGlobalSetting("auth");
    useRootStore("AuthStore");
    const navigate = useNavigate();

    const addUserAvatar: AvatarProps = useMemo(
        () => ({
            icon: <PersonAddRegular />,
            size: 32
        }),
        []
    );

    const reLoginNewUser = useCallback(() => {
        navigate("/login", { state: { interactionType: InteractionType.Redirect } });
    }, [navigate]);

    return (
        <>
            <Divider />
            {noneLoginUsers.map((user) => (
                <UserDropDownCachedUser key={user.homeAccountId} user={user} />
            ))}
            <MenuItem className={classNames.cachedItem} onClick={reLoginNewUser} aria-label="Sign in with a different account">
                <Persona avatar={addUserAvatar} primaryText="Sign in with a different account" />
            </MenuItem>
        </>
    );
};

export const UserDropDownCachedUsers = observer(UserDropDownCachedUsersBase);
